import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import ReactCountryFlag from "react-country-flag";
import fbLogo from '../../img/fb-logo.png';
import googleLogo from '../../img/google-logo.png';
import appleLogo from '../../img/apple-logo.png';
import { GOOGLE_AUTH_URL, FACEBOOK_AUTH_URL, APPLE_AUTH_URL } from '../../util/constants';
import logo from '../../img/timologic_login.png';
import LogoEmpty from '../../img/logo-empty.png';
import myDATALogo from '../../img/mydata.png';
import { Link } from 'react-router-dom';
import '../../styles/login-register-layout.css';

function SocialLogin() {
    const { t } = useTranslation();
    if (window.location !== window.parent.location) return null;

    const go = (provider) => {
        const urls = { google: GOOGLE_AUTH_URL, fb: FACEBOOK_AUTH_URL, apple: APPLE_AUTH_URL };
        window.location.href = urls[provider];
    };

    return (
        <div className="llr-social">
            <p className="llr-social-label">{t("ConnectWith")}</p>
            <div className="llr-social-buttons">
                <button type="button" className="llr-social-btn" onClick={() => go("google")}>
                    <img src={googleLogo} alt="Google" />
                </button>
                <button type="button" className="llr-social-btn" onClick={() => go("fb")}>
                    <img src={fbLogo} alt="Facebook" />
                </button>
                <button type="button" className="llr-social-btn" onClick={() => go("apple")}>
                    <img src={appleLogo} alt="Apple" />
                </button>
            </div>
            <div className="llr-divider"><span>{t("or")}</span></div>
        </div>
    );
}

const LoginRegisterLayout = (props) => {
    const { t, i18n } = useTranslation();

    if (i18n.language === "en-US") i18n.changeLanguage("gr");

    const getLogo = () => {
        if (window.location !== window.parent.location) {
            window.parent.postMessage("messageFromLogin", "*");
            return LogoEmpty;
        }
        return logo;
    };

    const changeLang = (e, lang) => {
        e.preventDefault();
        i18n.changeLanguage(lang.toLowerCase());
    };

    return (
        <div className="llr-page">
            <div className="llr-card">

                <div className="llr-header">
                    <img src={getLogo()} alt="Timologic" className="llr-logo" />
                    <p className="llr-subtitle">{t("InvoiceApplication")}</p>
                </div>

                <SocialLogin />

                <div className="llr-body">
                    {props.children}
                </div>

                <div className="llr-footer">
                    <small>{t("forgotPassMess")}<Link to="/forgot">{t("here")}!</Link></small>
                    <div className="llr-flags">
                        <a href="#" onClick={(e) => changeLang(e, "GB")}>
                            <ReactCountryFlag countryCode="GB" svg style={{ fontSize: '1.6em' }} />
                        </a>
                        <a href="#" onClick={(e) => changeLang(e, "GR")}>
                            <ReactCountryFlag countryCode="GR" svg style={{ fontSize: '1.6em' }} />
                        </a>
                    </div>
                </div>

            </div>

            <div className="llr-mydata-badge">
                <span>{t("myDataCompatibleMessage")}<img src={myDATALogo} alt="myDATA" className="llr-mydata-logo" /> </span>

            </div>

            {props.footer && (
                <div className="llr-page-footer">{props.footer}</div>
            )}
        </div>
    );
};

export default LoginRegisterLayout;
